import forge from "node-forge";

// Cargar la clave pública desde el servidor (directamente al cargar el archivo JS)
let publicKey = null;

async function loadPublicKey() {
    try {
        // const response = await fetch("/assets/keys/public_key.pem");

        // if (!response.ok) {
        //     throw new Error(`Error al cargar la clave pública: ${response.statusText}`);
        // }

        // const responseText = await response.text();

        // // Verificar que el archivo tiene el formato de clave pública .pem
        // if (
        //     !responseText.includes("-----BEGIN PUBLIC KEY-----") ||
        //     !responseText.includes("-----END PUBLIC KEY-----")
        // ) {
        //     throw new Error("El archivo .pem no tiene el formato adecuado");
        // }

        // publicKey = responseText;

        publicKey = process.env.VUE_APP_PUBLIC_KEY
        console.log("Clave pública cargada correctamente:", publicKey);
    } catch (error) {
        console.error("Error:", error.message);
    }
}



// Cargar la clave pública automáticamente al importar el archivo
loadPublicKey();

// Función para generar la clave AES-GCM
export async function generateEncrypKey() {
    const key = await window.crypto.subtle.generateKey(
        {
            name: "AES-GCM",
            length: 256, // Puedes usar 128, 192 o 256 bits
        },
        true, // Permitir exportar la clave
        ["encrypt", "decrypt"] // Operaciones permitidas
    );
    return key;
}

// Función para encriptar datos con AES-GCM
export async function encryptData(dataToEncrypt) {
    const key = await generateEncrypKey();

    // Convertir la clave a Base64 antes de enviarla
    const exportedKey = await window.crypto.subtle.exportKey("raw", key);
    const keyBase64 = btoa(
        String.fromCharCode(...new Uint8Array(exportedKey))
    );

    // Generar un vector de inicialización (IV) aleatorio
    const iv = window.crypto.getRandomValues(new Uint8Array(12)); // AES-GCM usa un IV de 12 bytes

    // Encriptar los datos
    const encryptedData = await window.crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        dataToEncrypt // Datos a encriptar (ArrayBuffer)
    );

    // AES-GCM incluye el `tag` automáticamente en los datos cifrados
    const encryptedArray = new Uint8Array(encryptedData);

    // El tag es los últimos 16 bytes de los datos cifrados
    const tag = encryptedArray.slice(-16); // 16 bytes de tag
    const tagBase64 = btoa(String.fromCharCode(...tag));

    // Convertir el resto de los datos en Base64
    const encryptedBase64 = btoa(
        String.fromCharCode(
            ...encryptedArray.slice(0, encryptedArray.length - 16)
        )
    );
    const ivBase64 = btoa(String.fromCharCode(...iv)); // Convertir IV a Base64

    return {
        encryptedData: encryptedBase64,
        iv: ivBase64,
        key: keyBase64, // Devolver la clave en formato Base64
        tag: tagBase64, // Devolver el tag en formato Base64
    };
}

// Función para encriptar texto con RSA usando la clave pública cargada globalmente
export function encryptTextWithRsa(text) {
    if (!publicKey) {
        throw new Error("No se ha cargado la clave pública.");
    }

    try {
        const key = forge.pki.publicKeyFromPem(publicKey);
        const encrypted = key.encrypt(text, "RSA-OAEP");
        return forge.util.encode64(encrypted);
    } catch (error) {
        throw new Error(`Error al cifrar el mensaje: ${error}`);
    }
}